import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const GetPatientOrderBlockConfigSchema = z.object({
  orderId: z.string().optional(),
});
export type GetPatientOrderBlockConfig = z.infer<typeof GetPatientOrderBlockConfigSchema>;

export const GetPatientOrderBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.GetPatientOrder),
  returnType: returnTypeSchema(ProducedType.PatientOrder),
  config: GetPatientOrderBlockConfigSchema,
});
export type GetPatientOrderBlock = z.infer<typeof GetPatientOrderBlockSchema>;
